module.exports = __webpack_public_path__ + "static/media/tbot.966e7c1c.png";